// External Imports
import { useEffect, useState } from "react";
import DetailPair from "../UI/DetailPair";
import { requestAdminAPI } from "../../api/posh-api";

// Internal Imports

/** ========================================================================
 * * GeneralInfo Component
 * This component renders current statistics.
 * ========================================================================== */

export default function GeneralInfo() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  /* ====================== FETCH DATA ====================== */
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await requestAdminAPI("fetch-all", {
        table: "vehicle",
      });
      const newData = {
        available: 0,
        unavailable: 0,
        inventory: 0,
        booked: 0,
        notBooked: 0,
        maintenance: 0,
        utilization: 0,
        availability: 0,
      };
      response.forEach((vehicle) => {
        if (vehicle.available) newData.available += 1;
        else if (vehicle.status === "maintenance") newData.unavailable += 1;
        if (vehicle.activeBookingId) newData.booked += 1;
        else newData.notBooked += 1;
        if (vehicle.status === "maintenance") newData.maintenance += 1;
      });
      newData.inventory = newData.available + newData.unavailable;
      if (newData.available > 0) {
        if (newData.booked > 0)
          newData.utilization = Math.round(
            (newData.booked / newData.available) * 100
          );
      }
      if (newData.inventory > 0) {
        newData.availability = Math.round(
          (newData.available / newData.inventory) * 100
        );
      }
      setData(newData);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="info">
      <DetailPair
        label="Vehicle Utilization"
        value={`${data.booked} / ${data.available} = ${data.utilization || "-"}%`}
        loading={loading}
      />
      <DetailPair
        label="Vehicle Availability"
        value={`${data.available} /  ${data.inventory} = ${data.availability || "-"}%`}
        loading={loading}
      />
    </div>
  );
}
